import { createSlice } from '@reduxjs/toolkit';
import {
  fetchAllFoodsAndTaco4Foods,
  fetchAllFoodsAndTacoFoods,
} from '../actions/foodActions';

const foodsAndTacoFoodsSlice = createSlice({
  name: 'foodsAndTacoFoods',
  initialState: {
    foodsAndTacoFoods: [],         // Lista de todos os alimentos Foods e Taco_Foods
    currentFoodOrTaco: null, // Alimento Taco atualmente selecionado
    foodsAndTaco4Foods: [], // Lista de todos os alimentos Foods e Taco_Foods
    currentFoodOrTaco4: null, // Alimento Taco atualmente selecionado
    loading: false,        // Estado de carregamento
    error: null,           // Estado de erro
  },
  reducers: {
    setCurrentFoodOrTaco: (state, action) => {
      state.currentFoodOrTaco = action.payload;
    },
    setCurrentFoodOrTaco4: (state, action) => {
      state.currentFoodOrTaco4 = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllFoodsAndTacoFoods.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllFoodsAndTacoFoods.fulfilled, (state, action) => {
        state.loading = false;
        state.foodsAndTacoFoods = Array.isArray(action.payload.foods) ? action.payload.foods : [];
      })
      .addCase(fetchAllFoodsAndTacoFoods.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Erro ao carregar alimentos';
      })
      .addCase(fetchAllFoodsAndTaco4Foods.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllFoodsAndTaco4Foods.fulfilled, (state, action) => {
        state.loading = false;
        state.foodsAndTaco4Foods = Array.isArray(action.payload.data) ? action.payload.data : [];
        // console.log('Slice foodsAndTaco4Foods: ', action.payload.data);
      })
      .addCase(fetchAllFoodsAndTaco4Foods.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Erro ao carregar alimentos';
      })
      ;
  },
});

export const { setCurrentFoodOrTaco, setCurrentFoodOrTaco4 } = foodsAndTacoFoodsSlice.actions;
export default foodsAndTacoFoodsSlice.reducer;